export const REMOTE_FEATURE_FLAG_PROXY_PATH = '/ff/precompute-assignments'
